import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

@Injectable()
export class AppActions {

	static USER_LOGGED_IN = "[Application] User logged in";
	userLoggedIn(): Action {
		return {
			type: AppActions.USER_LOGGED_IN
		}
	}

}


// WEBPACK FOOTER //
// ./src/app/actions/app.actions.ts